import axios, { AxiosResponse, AxiosError } from 'axios';
import { MAIL_MAGAZINE_URL } from '../../constants/routes/urls';
import MailMagazineService from '../../usecases/ports/MailMagazineService';

type ACCESS_TOKEN_RESPONSE = {
  access_token: string;
  expires_in: number;
};

type REGISTER_RESPONSE = {
  result: 'Success';
};

type MAIL_MAGAZINE_API_ERROR = {
  Error: string;
  error_description: string;
};

export default class MailMagazineServiceImpl implements MailMagazineService {
  clientId: string;
  clientSecret: string;
  magazineId: string;

  constructor(clientId: string, clientSecret: string, magazineId: string) {
    this.clientId = clientId;
    this.clientSecret = clientSecret;
    this.magazineId = magazineId;
  }

  getAccessToken = async (): Promise<string> => {
    const url = `${MAIL_MAGAZINE_URL}?path=token&client_id=${this.clientId}&client_secret=${this.clientSecret}`;

    return await axios
      .post(url)
      .then((response: AxiosResponse<ACCESS_TOKEN_RESPONSE>) => {
        const { data } = response;

        return data.access_token;
      })
      .catch((error: AxiosError<MAIL_MAGAZINE_API_ERROR>) => {
        throw error.response ? error.response.data : error;
      });
  };

  registerToMailMagazine = async (
    accessToken: string,
    email: string,
    name: string,
  ): Promise<string> => {
    const url = `${MAIL_MAGAZINE_URL}?path=userAdd&access_token=${accessToken}&magazine_id=${this.magazineId}&email=${email}&name=${name}&mail_send=0&subreason=api`;

    return await axios
      .get(url)
      .then((response: AxiosResponse<REGISTER_RESPONSE>) => {
        return response.data.result;
      })
      .catch((error: AxiosError<MAIL_MAGAZINE_API_ERROR>) => {
        throw error.response ? error.response.data : error;
      });
  };
}
